module.exports = __webpack_public_path__ + "img/activeToggleButton.5aa17165.svg";